import type { ReactNode } from 'react';
import type { ViewerCamera } from '@geosoft/viewer-sdk';
import { Stack, tokens } from '@/design';
import { MapStatusBar } from '@/components/map/MapStatusBar';
import type { MapStateFlags } from '@/components/map/mapModel';

interface ShellBottomBarProps {
  camera: ViewerCamera | null;
  crs: string;
  flags: MapStateFlags;
  timeline: ReactNode;
  supplementalStatus?: ReactNode;
}

export function ShellBottomBar({
  camera,
  crs,
  flags,
  timeline,
  supplementalStatus,
}: ShellBottomBarProps) {
  return (
    <footer
      role="contentinfo"
      aria-label="Workspace status"
      style={{
        borderTop: tokens.border.thin,
        background: tokens.color.surface[1],
        minHeight: tokens.layout.bottomBarHeight,
        paddingInline: tokens.space[2],
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: tokens.space[2],
      }}
    >
      <Stack direction="row" align="center" gap={2} style={{ flexWrap: 'wrap', minWidth: 0 }}>
        <section aria-label="Map status slot" role="status" aria-live="polite">
          <MapStatusBar camera={camera} crs={crs} flags={flags} />
        </section>
        {supplementalStatus ? (
          <section aria-label="3D and point cloud status slot" role="status" aria-live="polite">
            {supplementalStatus}
          </section>
        ) : null}
      </Stack>

      <section aria-label="Timeline slot" style={{ flex: '0 0 auto' }}>{timeline}</section>
    </footer>
  );
}
